/* src/app/modules/bank-accounts/components/add-edit-user-bank-information/add-edit-user-bank-information.component.scss */
/*# sourceMappingURL=add-edit-user-bank-information.component.css.map */
